import React from 'react';
import { ArrowRight, Download, Linkedin } from 'lucide-react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section id="home" className="pt-[200px] pb-[100px] w-full bg-dark text-white/65 text-base leading-[30px] font-inter overflow-hidden" data-id="element-104">
      <div className="max-w-[1320px] mx-auto px-[15px]" data-id="element-105">
        <div className="flex flex-wrap items-center -mx-[15px]" data-id="element-106">
          <div className="shrink-0 w-full max-w-full px-[15px]" data-id="element-107">
            {/* Hero Content */}
            <div className="text-center relative px-4 md:px-[250px] mb-[60px]" data-id="element-108">
              <motion.h2 initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5
            }} className="font-normal leading-6 text-white/[0.69] text-xl font-syne mb-[5px]" data-id="element-109">
                Hi! 👋 My name is Sage Stephens
              </motion.h2>
              <motion.h1 initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} className="font-bold leading-tight md:leading-[95px] text-white text-5xl md:text-[90px] font-syne mb-[25px]" data-id="element-110">
                Web Developer &{' '}
                <span className="text-gold relative inline-block" data-id="element-111">
                  UX
                  {/* Underline decoration */}
                  <svg className="absolute w-full h-3 -bottom-1 left-0 text-gold" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-112">
                    <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="2" fill="none" data-id="element-113" />
                  </svg>
                </span>{' '}
                Specialist
              </motion.h1>

              {/* Decorative Shape - Left */}
              <div className="absolute left-[10%] top-[20%] animate-rotate-circle hidden lg:block opacity-60" data-id="element-114">
                <div className="w-12 h-12 border-2 border-dashed border-white/20 rounded-full" data-id="element-115"></div>
              </div>

              {/* Decorative Shape - Right */}
              <div className="absolute right-[10%] top-[40%] animate-rotate-circle hidden lg:block opacity-60" data-id="element-116">
                <div className="w-8 h-8 bg-gold/20 rounded-full" data-id="element-117"></div>
              </div>

              {/* CTA Button */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} className="flex flex-wrap items-center justify-center gap-4 mt-[15px]" data-id="element-118">
                <a href="#contact" className="inline-flex items-center justify-center text-lg font-semibold leading-5 border rounded px-10 py-[15px] transition-all duration-300 cursor-pointer font-inter whitespace-nowrap bg-gold text-true-white border-black shadow-[4px_4px_0px_0px_#fff,4px_4px_0px_1px_#000] hover:-translate-y-1 hover:shadow-[6px_6px_0px_0px_#fff,6px_6px_0px_1px_#000]" data-id="element-119">
                  Hire Me{' '}
                  <ArrowRight className="inline-block w-[18px] h-[18px] align-middle ml-2" data-id="element-120" />
                </a>

                {/* ⬇️ Replace the href below with your actual CV file URL */}

                <a href="https://www.linkedin.com/in/sageartitstudio/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center text-lg font-semibold leading-5 border rounded px-10 py-[15px] transition-all duration-300 cursor-pointer font-inter whitespace-nowrap bg-transparent text-white border-white hover:bg-white hover:text-black hover:border-black shadow-[4px_4px_0px_0px_#046bd2,4px_4px_0px_1px_#000] hover:shadow-[4px_4px_0px_0px_#fff,4px_4px_0px_1px_#000]" data-id="element-121">
                  LinkedIn{' '}
                  <Linkedin className="inline-block w-[18px] h-[18px] align-middle ml-2" data-id="element-122" />
                </a>
              </motion.div>
            </div>

            {/* Stats Bar */}
            <div className="mx-auto max-w-[1032px]" data-id="element-123">
              <motion.div initial={{
              scaleX: 0,
              opacity: 0
            }} animate={{
              scaleX: 1,
              opacity: 1
            }} transition={{
              scaleX: {
                duration: 0.8,
                delay: 3,
                ease: [0.22, 1, 0.36, 1]
              },
              opacity: {
                duration: 0.3,
                delay: 3
              }
            }} style={{
              originX: 0.5
            }} className="flex flex-col md:flex-row justify-around items-center bg-gold rounded-[50px] py-[35px] px-10 gap-8 md:gap-0 overflow-hidden" data-id="element-124">
                {[{
                value: '6+',
                label: 'Years Of Experience'
              }, {
                value: '1k+',
                label: 'Complete Projects'
              }, {
                value: '90%+',
                label: 'Client Satisfactions'
              }].map((stat, index) => <motion.div key={stat.label} className="text-center" initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.5,
                delay: 3.6 + index * 0.15,
                ease: 'easeOut'
              }} data-id="element-125">
                    <span className="text-dark-text text-[40px] md:text-[50px] leading-[50px] font-bold font-syne block" data-id="element-126">
                      {stat.value}
                    </span>
                    <span className="text-dark-text block font-inter font-medium" data-id="element-127">
                      {stat.label}
                    </span>
                  </motion.div>)}
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}